import LayerAttribute from './LayerAttribute';

function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function getFeatureValue(feature: any, key: string): unknown {
  if (feature.properties && feature.properties.getValue) {
    return feature.properties.getValue()[key];
  }
  if (feature.get && feature.get(key) === undefined) {
    return '';
  }
  return feature.get ? feature.get(key) : feature.getProperties()[key];
}

function getAttributeLabel(layerProperties: LayerAttribute[], key: string): string {
  const attribute = layerProperties.find((el) => el.name === key);
  if (attribute && attribute.label) {
    return attribute.label;
  }
  return key;
}

function isLink(value: unknown): boolean {
  return typeof value === 'string' && value.indexOf('http') === 0;
}

function formatValueHtml(value: unknown): string {
  const escaped = escapeHtml(value);
  if (isLink(value)) {
    return `<a target="blank" href="${escaped}">${escaped}</a>`;
  }
  return escaped;
}

function getFeatureKeys(feature: any): string[] {
  if (feature.getKeys) {
    return feature.getKeys();
  }
  return Object.keys(feature.getProperties());
}

function shallDisplayAttribute(
  key: string,
  layerProperties: LayerAttribute[],
  displayFlag: 'display' | 'display_in_popup',
): boolean {
  return layerProperties.some((el) => el.name === key && el[displayFlag]);
}

function buildRow(label: string, value: unknown): string {
  return `<div class="item label">${escapeHtml(label)}</div><div class="item">${formatValueHtml(value)}</div>`;
}

export default class FeatureInfoUtils {
  static getFeatureValue(feature: any, key: string): unknown {
    return getFeatureValue(feature, key);
  }

  static getFeatureKeys(feature: any): string[] {
    return getFeatureKeys(feature);
  }

  static getAttributeLabel(layerProperties: LayerAttribute[], key: string): string {
    return getAttributeLabel(layerProperties, key);
  }

  static shallDisplayAttribute(
    key: string,
    layerProperties: LayerAttribute[],
    displayFlag: 'display' | 'display_in_popup',
  ): boolean {
    return shallDisplayAttribute(key, layerProperties, displayFlag);
  }

  static isLink(value: unknown): boolean {
    return isLink(value);
  }

  static getDisplayKeys(
    feature: any,
    layerProperties: LayerAttribute[],
    displayFlag: 'display' | 'display_in_popup' = 'display',
  ): string[] {
    const geometryName = feature.geometryName_ || 'geometry';
    const keys: string[] = [];

    if (layerProperties && layerProperties.length > 0) {
      getFeatureKeys(feature).forEach((key) => {
        if (key === geometryName) {
          return;
        }
        const value = getFeatureValue(feature, key);
        if (shallDisplayAttribute(key, layerProperties, displayFlag) && value !== undefined) {
          keys.push(key);
        }
      });
    } else {
      getFeatureKeys(feature).forEach((key) => {
        if (key === geometryName) {
          return;
        }
        const value = getFeatureValue(feature, key);
        if (value) {
          keys.push(key);
        }
      });
    }

    return keys;
  }

  static buildAttributesTableHtml(
    feature: any,
    layerProperties: LayerAttribute[],
    displayFlag: 'display' | 'display_in_popup' = 'display_in_popup',
  ): string {
    const keys = FeatureInfoUtils.getDisplayKeys(feature, layerProperties, displayFlag);
    const rows = keys.map((key) => {
      const label = layerProperties && layerProperties.length > 0
        ? getAttributeLabel(layerProperties, key)
        : key;
      return buildRow(label, getFeatureValue(feature, key));
    });

    if (rows.length === 0) {
      return '';
    }

    return `<div class="att-list"><div class="container_table">${rows.join('')}</div></div>`;
  }
}
